/**
 * Game-wide constants: canvas size, how art is rasterized, and the layout
 * anchors the scenes share. Tuned to the storybook reference composition (4:3).
 */

/** Logical design resolution (4:3, matching the reference art). */
export const GAME_W = 1280;
export const GAME_H = 960;

/** SVGs are rasterized at this multiple of their logical size, for crisp art
 * on high-DPI screens. Display sizes still use the logical (1×) numbers. */
export const RENDER_SCALE = 2;

/** The customer animal, behind the counter, center-left. */
export const CUSTOMER = { x: GAME_W * 0.25, y: GAME_H * 0.64, scale: 1.0 };

/** Order speech bubble, top-left. */
export const BUBBLE = { x: GAME_W * 0.12, y: GAME_H * 0.22 };

/** Where the ice cream is built (the cone's seat) and the plate it stands on. */
export const BUILD = { x: GAME_W * 0.4, y: GAME_H * 0.42 };
export const PLATE = { x: GAME_W * 0.4, y: GAME_H * 0.605 };

/** Serve (bell) button, center on the counter. */
export const BELL = { x: GAME_W * 0.51, y: GAME_H * 0.49, r: 58 };

/** Coin price-board (top-right), slot-card (mid-right), earnings jar (far right). */
export const COIN_BOARD = { x: GAME_W * 0.7, y: GAME_H * 0.25 };
export const COIN_CARD = { x: GAME_W * 0.69, y: GAME_H * 0.5 };
export const JAR = { x: GAME_W * 0.9, y: GAME_H * 0.5 };

/** Vertical overlap of stacked scoops and where the first scoop seats on a
 * base. Tuned to the cone/cup art in builders/foods.ts (scoop art is 200×175,
 * displayed ~132 wide). */
export const SCOOP_STACK_DY = 52; // distance between scoop centers
export const SEAT_RISE = 30; // first scoop center sits this far above the base seat

/** Origin Y (0..1) placing each base's "seat" (opening) under the first scoop.
 * cone rim is at y=46 in a 200-tall viewBox; cup rim at y=62 in 190. */
export const BASE_SEAT_ORIGIN: Record<string, number> = {
  cone: 46 / 200,
  cup: 62 / 190,
};

/** Coins needed in the jar to feel "full" (purely visual celebration). */
export const JAR_CAPACITY = 12;
